"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Caption2: function() {
        return _index.Caption2;
    },
    caption2ClassNames: function() {
        return _index.caption2ClassNames;
    }
});
const _index = require("./components/presets/Caption2/index");
